module.exports = __webpack_public_path__ + "img/MepaniJ.30add9e0.jpg";